import { render, staticRenderFns } from "./Section12.vue?vue&type=template&id=e10c7b82&scoped=true&"
import script from "./Section12.vue?vue&type=script&lang=js&"
export * from "./Section12.vue?vue&type=script&lang=js&"
import style0 from "./Section12.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Section12.vue?vue&type=style&index=1&id=e10c7b82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e10c7b82",
  null
  
)

export default component.exports